import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { UncontrolledTooltip } from "reactstrap";

import relativeDayjs, { CALENDAR_SETTINGS } from "./helpers/relativeDayjs";
import { commentEditLabel } from "./styles/Comments.module.scss";

const CommentEditedLabel = ({ lastEditedAt }) => {
  const labelRef = useRef();

  return (
    <div>
      <div ref={labelRef} className={commentEditLabel} data-test-id="edit-label">(edited)</div>
      <UncontrolledTooltip placement="right" target={labelRef}>
        {relativeDayjs(lastEditedAt).calendar(...CALENDAR_SETTINGS)}
      </UncontrolledTooltip>
    </div>
  );
};

CommentEditedLabel.propTypes = {
  lastEditedAt: PropTypes.string
};

export default CommentEditedLabel;
